# 日程相关全局脚本

$ ->
  tower.stack.on 'pageunload', (e) ->
    $(document).off("keyup.calendar-events-selector")
    return e.result

tower.initCalendarEventsSelector = ->
  dateEl = $(".calendar-events-topbar .date")
  dateEl.text(tower.moment(dateEl.data("date")).format("YYYY MMMM"))

  $(".calendar-events-topbar").on("click", ".left, .right", (e) ->
    e.preventDefault()

    target = $(@)
    dateEl = $(".calendar-events-topbar .date")
    monthStart = tower.moment(dateEl.data("date"))
    monthStart.add((if target.is(".left") then -1 else 1), "month")
    dateEl.text(monthStart.format("YYYY MMMM"))
      .attr("data-date", monthStart)
      .data("date", monthStart)

    url = simple.url()
    url.search.start_at = monthStart.format("YYYY-MM-DD")
    url.hash = ""

    #pageEl = $('.workspace .page:last .page-inner')
    #parentEl = pageEl.parent '.page'
    #if parentEl.length > 0
      #parentLink = parentEl.find('.sheet-header:first a')
      #parent =
        #name: parentLink.text()
        #url: parentLink.attr 'href'

    tower.stack.load url.toString("relative"),
      replace: true
  )


  $(document).off("keyup.calendar-events-selector").on("keyup.calendar-events-selector", (e) ->
    target = $(e.target)
    return if target.is('input, textarea, [contenteditable]')

    if /37/.test(e.which)
      $(".calendar-events-topbar .left").trigger('click')
      return false
    else if /39/.test(e.which)
      $(".calendar-events-topbar .right").trigger('click')
      return false
  )

# 给时间字段赋值
tower.refreshEventTime = ($wrapper, type) ->
  $date = $wrapper.find(".link-#{type}-date")
  $time = $wrapper.find(".link-#{type}-time")
  datetime = "#{$date.data 'date'} #{$time.data 'time'}"
  $wrapper.find("[name=#{type}s_at]").val(datetime)
